"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgUserTimes = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M17 7A5 5 0 117 7a5 5 0 0110 0zm-2 0a3 3 0 10-6 0 3 3 0 006 0zM2 20c0-4 2.001-6 6.004-6h3.252c0 .748.183 1.415.55 2H8c-2.667 0-4 1.333-4 4h7.555c-.158.317-.237.984-.237 2H4c-1.333 0-2-.667-2-2zm13.671-5.743l2.243 2.242 2.242-2.242c.464-.48.935-.48 1.415 0s.48.95 0 1.414l-2.243 2.243 2.243 2.242c.471.472.471.943 0 1.415-.472.471-.943.471-1.415 0l-2.242-2.243-2.243 2.243c-.46.482-.932.482-1.414 0-.482-.483-.482-.954 0-1.415l2.242-2.242-2.242-2.243c-.472-.47-.472-.942 0-1.414s.943-.472 1.414 0z' }))); };
exports.default = SvgUserTimes;
//# sourceMappingURL=UserTimes.js.map